<template>
  <div class="main_body_store">
    <div class="main_head_store">
      <div style="margin-top: 12.5rem">
        <div class="good-comments-button" @click="showChoose">去应用市场好评</div>
        <div class="get-rewards-button" @click="getAward">领取好评奖励</div>
      </div>
    </div>
    <!-- 弹框 -->
    <el-dialog style="width: 15rem;margin-left: -2.5rem;margin-top: 3rem" :visible.sync="dialogVisible" size="small"
               center :show-close="false">
      <div style="align-content: center">
        <img src="../../../../assets/store/market.svg" class="market-css">
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button type="warning" @click="goMarket(false)" plain size="small">直 接 去 好 评</el-button>
    <el-button type="primary"  @click="goMarket(true)"  plain size="small">复 制 去 好 评</el-button>
  </span>
    </el-dialog>


  </div>

</template>

<script>
import {randomGain} from "../../../../api/comment/comment";

export default {
  data() {
    return {
      commentGood: null,
      // 弹窗
      dialogVisible: false,
      count:"",//倒计时

    }

  },

  // 方法
  methods: {
    // 弹框选择
    showChoose() {
      this.dialogVisible = true
      // window.android.goMarket();
    },
    // 应用市场
    goMarket(flag) {
      this.dialogVisible = false;
      if (flag) {
        this.copy();
      } else {
        window.android.goMarket();
      }
    },
    //复制好评
    copy() {
      randomGain(1).then(response => {
        if (response.data) {
          this.$copyText(response.data).then(res => {
            if (res.code) this.$message.error(res.code)
            this.startDivi()
            // this.$message({
            //   message: '复制成功',
            //   type: 'success'
            // });
          })
        }
      })
    },
    // 跳转客服
    getAward() {
      window.android.getAward();
    },
    //3秒后进入跳转页面
    startDivi() {
     const loading= this.$loading({
        lock: true,
        text: '评论语复制成功，粘贴使用即可，正在跳转',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(() => {
        loading.close();
        window.android.goMarket();
      }, 2500);
    }
    },
}
</script>

<style>
.main_body_store {
  display: flex;
  height: auto;
  flex-flow: column nowrap;
}

.el-dialog--center .el-dialog__body {
  padding: 7px 16px 0px;
}

.main_head_store {
  width: 100%;
  height: 0;
  padding-bottom: 228%;
  background-image: url('../../../../assets/store/store.png');
  background-size: 100%;
}

.good-comments-button {
  width: 5.6rem;
  left: 0;
  right: 0;
  color: white;
  height: 0.75rem;
  font-size: 0.5rem;
  margin: auto auto 0.4rem;
  font-family: ”Microsoft YaHei”, Arial, Helvetica, sans-serif, ”宋体”;
  box-shadow: 0 1px 3px rgba(0, 0, 0, .19), inset 0 1px 0 rgba(255, 255, 255, .4);
  font-weight: bold;
  padding: 0.3rem;
  background: #FF833A;
  border-radius: 1.8rem;
  border: none;
  text-align: center;
}

.get-rewards-button {
  width: 5.5rem;
  left: 0;
  right: 0;
  height: 0.70rem;
  font-size: 0.5rem;
  margin: auto auto 0.5rem;
  font-family: ”Microsoft YaHei”, Arial, Helvetica, sans-serif, ”宋体”;
  box-shadow: 0 1px 3px rgba(0, 0, 0, .19), inset 0 1px 0 rgba(255, 255, 255, .4);
  font-weight: bold;
  padding: 0.3rem;
  background: #FFFFFF;
  border-radius: 1.8rem;
  border: solid 2px;
  color: #FF4D61;
  text-align: center;
}

.get-good-comment {
  margin: auto auto 0.5rem;
  padding: 0.2rem;
  opacity: 0.6;
  height: 0.70rem;
  border-radius: 6px;
  /*border: 1px solid rgba(151, 151, 151, 1);*/
  color: rgba(255, 155, 35, 100);
  font-size: 0.3rem;
  text-align: left;
  font-family: SourceHanSansSC-Regular;
  border: 1px dashed rgba(151, 151, 151, 1);
}

input[type=button] {
  background: none;
}

.el-dialog__body {
  padding: 10px 23px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}

.market-css {
  height: 2.5rem;
  width: 2.5rem;
  margin: auto 2.15rem 0;
  text-align: center;
}

.el-dialog__header {
  padding: 1px 1px 4px;
}

.el-button + .el-button {
  margin-left: 2px;
}

</style>



// WEBPACK FOOTER //
// src/view/pomelo/app/store/index.vue